'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
import { NavbarSection } from '@algoacademy/design-system/web/navigation/Navbar';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Fragment, useState } from 'react';
import { NavbarMobileArticleSidebarSection } from './_components/NavbarMobileArticleSidebarSection';
import { NavbarMobileAuthSection } from './_components/NavbarMobileAuthSection';
import { NavbarMobileExternalLinks } from './_components/NavbarMobileExternalLinks';
type NavbarMobileProps = {
  userLogged: boolean;
};
export function NavbarMobile(t0) {
  const $ = _c(18);
  const {
    userLogged
  } = t0;
  const pathname = usePathname();
  const hrefRedirect = `redirectTo=${encodeURIComponent(pathname)}`;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeDrawer = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" aria-label={"Otw\xF3rz menu"} className="inline-flex items-center justify-center rounded-md p-2.5 text-contentPrimary" onClick={() => setOpen(true)}><Bars3Icon className="h-6 w-6 text-contentInverseSecondary" /></button>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/25" /></TransitionChild>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex lg:flex-1"><Link href="/baza" onClick={closeDrawer}><Image src="/logos/logo-full-horizontal-dark.svg" alt="logo" width={160} height={20} className="hidden dark:block" /><Image src="/logos/logo-full-horizontal-light.svg" alt="logo" width={160} height={20} className="dark:hidden" /></Link></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center justify-between">{t4}<button type="button" aria-label="Zamknij menu" className="rounded-md p-2.5 text-contentPrimary" onClick={closeDrawer}><XMarkIcon className="h-6 w-6 text-contentInverseSecondary" /></button></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== userLogged) {
    t6 = <NavbarMobileArticleSidebarSection isLoggedIn={userLogged} onNavigate={closeDrawer} />;
    $[5] = userLogged;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavbarMobileExternalLinks onNavigate={closeDrawer} />;
    t8 = <Divider />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== hrefRedirect || $[10] !== userLogged) {
    t9 = <NavbarMobileAuthSection userLogged={userLogged} hrefRedirect={hrefRedirect} onNavigate={closeDrawer} />;
    $[9] = hrefRedirect;
    $[10] = userLogged;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t9) {
    t10 = <Dialog as="div" className="lg:hidden" onClose={closeDrawer}>{t3}<TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="-translate-x-full opacity-0" enterTo="translate-x-0 opacity-100" leave="ease-in duration-200" leaveFrom="translate-x-0 opacity-100" leaveTo="-translate-x-full opacity-0"><DialogPanel className="fixed inset-y-0 left-0 z-100 w-full max-w-100 overflow-y-auto bg-backgroundSecondary px-4 py-2.5">{t5}<div className="flex flex-col gap-6 py-6">{t6}{t7}{t8}{t9}</div></DialogPanel></TransitionChild></Dialog>;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== open || $[16] !== t10) {
    t11 = <NavbarSection>{t2}<Transition show={open} as={Fragment}>{t10}</Transition></NavbarSection>;
    $[15] = open;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}